import * as PROFILE_CARDS_EVENTS from '../../../../events/profile-cards';

Hop.defineModule('profile-card-skills-rebrand2020', (domRoot, param) => {
    const $root = domRoot;
    const debounceCalculateSkills = Hop.debounce(resetMoreSkills, 100);
    const SHOW_MORE_WIDTH = 40;
    let $skills;
    let SKILLS_COUNT;

    function setContext($list) {
        $skills = $list.querySelectorAll('li');
        SKILLS_COUNT = $skills.length;
    }

    function moreSkillsTpl(count) {
        // Previously we used param.url to include a specific link (to the profile I guess)
        //  I think it's useless now ?
        // see lib-webcommon/webmvc-common/src/main/js/Hop/components/profile-card/profile-card-keywords.js -> moreKeywordsTpl

        let classes = param.tagSelector;
        classes = classes.split(' ');
        const li = document.createElement('li');
        li.classList.add('m-tag_more');

        classes.forEach((c) => {
            li.classList.add(c);
        });

        li.innerText = `+${count}`;
        li.setAttribute('data-more-skills', '');
        li.style.width = `${SHOW_MORE_WIDTH}px`;
        return li;
    }

    function hiddenSkillsCount(lastVisibleIdx) {
        return SKILLS_COUNT - lastVisibleIdx;
    }

    function addMoreSkillsCtaIfNeeded(idx) {
        if (idx && hiddenSkillsCount(idx + 1) > 0) {
            const li = moreSkillsTpl(hiddenSkillsCount(idx + 1));
            $root.querySelector('[data-skills-list]').insertBefore(li, $skills.item(idx + 1));
        }
    }

    function noSpaceEnoughForCountComponent(idx) {
        // We need to know if there are enough space at the right of last visible skill
        // If so, the +X item will fit, if not it will move to next line and will be invisible
        const lastVisibleItem = $skills.item(idx);
        if (lastVisibleItem) {
            const lastVisibleItemWidth = lastVisibleItem.offsetWidth + 5; // Margin-right of tag
            const lastVisibleItemLeft = lastVisibleItem.offsetLeft;
            const widthList = $root.querySelector('[data-skills-list]').offsetWidth;

            return widthList - (lastVisibleItemLeft + lastVisibleItemWidth) <= SHOW_MORE_WIDTH + 5;
        }
    }

    function isSkillLastChild(idx) {
        return !$skills.item(idx).nextElementSibling;
    }

    function isSkillHidden(idx) {
        const LIST_HEIGHT = $root.querySelector('[data-skills-list]').offsetHeight;
        const SKILL_OFFSET_TOP = $skills.item(idx).offsetTop;
        return !isSkillLastChild(idx) && SKILL_OFFSET_TOP >= LIST_HEIGHT;
    }

    function lastVisibleSkillIndex(idx = 0) {
        if (isSkillHidden(idx)) {
            idx = idx - 1;
        } else if (!isSkillLastChild(idx)) {
            idx = lastVisibleSkillIndex(idx + 1);
        }

        if (noSpaceEnoughForCountComponent(idx)) {
            // if our count component doesn't fit in visible space, we set the index with previous item
            idx = idx - 1;
        }

        return idx;
    }

    function checkSkillsList() {
        const $list = $root.querySelector('[data-skills-list]');
        $list.classList.remove('loaded');
        setContext($list);
        const index = lastVisibleSkillIndex();
        addMoreSkillsCtaIfNeeded(index);
        $list.classList.add('loaded');
    }

    function addListeners() {
        Object.keys(PROFILE_CARDS_EVENTS).forEach((event) => {
            Hop.events.on(PROFILE_CARDS_EVENTS[event], resetMoreSkills);
        });
        window.addEventListener('resize', debounceCalculateSkills);
    }

    function removeListeners() {
        Object.keys(PROFILE_CARDS_EVENTS).forEach((event) => {
            Hop.events.off(PROFILE_CARDS_EVENTS[event], resetMoreSkills);
        });
        window.removeEventListener('resize', debounceCalculateSkills);
    }

    function resetMoreSkills() {
        const $list = $root.querySelector('[data-skills-list]');
        const $moreSkills = $list.querySelector('[data-more-skills]');
        if ($moreSkills) {
            $moreSkills.remove();
        }
        checkSkillsList();
    }

    checkSkillsList();
    addListeners();

    return function destroy() {
        removeListeners();
    };
});
